import BaseEligibilityIndex from "../../common/controllers/BaseEligibilityIndex";

export default class BackofficeEligibilitiesIndex extends BaseEligibilityIndex {

    constructor() {
        super();
        let urlParams = new URLSearchParams(window.location.search);
        this.fromWorkflow = urlParams.get('from_workflow');
    }

    bindEvents() {
        super.bindEvents();
        if ($("#entity-select").length) {
            $("#entity-select").select2({
                minimumResultsForSearch: -1
            });
        }
        this.bindDetailButtons();
    }

    bindDetailButtons() {  
        let self = this;

        $(".go-to-details-btn").on("click", function() {
            let uuid = $(this).data("uuid");
    
            $("#submit-entity-choice").data("uuid", uuid);
    
            // Trigger change event to load members for the first entity by default
            $("#entity-select").trigger("change");
        });
    
        $("#entity-select").on("change", function() {
            let url = $(this).data("get-members-select-url");
    
            $.ajax({
                url: url,
                data: {entity: $(this).val()},
                method: "GET",
                success: function(data){
                    $("#members-select-wrapper").html(data);
                    $("#entity-members-select").select2({
                        placeholder: "Rechercher un client...",
                        width: '100%',
                        dropdownParent: $('#detailsModal'),
                        language: {
                            noResults: function() {
                                return "Aucun client trouvé";
                            },
                            searching: function() {
                                return "Recherche en cours...";
                            }
                        }
                    });
                }
            });
        });
    
        $("#submit-entity-choice").on("click", function() {
            let $button = $(this);
            let uuid = $button.data("uuid");
            let entity_id = $("#entity-select").val();
            let customer_id = $("#entity-members-select").val();
            let urlTemplate = $button.data("eligibility-show-url");

            let redirect_url = urlTemplate.replace("UUID_PLACEHOLDER", uuid);
            let url = new URL(redirect_url, window.location.origin);
            url.searchParams.set("entity", entity_id);
            url.searchParams.set("customer_id", customer_id);

            if (self.fromWorkflow) {
                url.searchParams.set("from_workflow", self.fromWorkflow);
            }

            window.location.href = url.toString();
        });
    }

    onDestroy() {
        super.onDestroy();
        if ($("#entity-select").hasClass("select2-hidden-accessible")) {
            $("#entity-select").select2("destroy");
        }
    }

    initFttoDatatables(){
        let $els = $('.ftto_datatable');
        if($els.length <= 0){ return false; }

        $els.each((index, element) => {
            let $el = $(element);
            let table = $el.DataTable({
                dom: 'rtp',
                responsive: false,
                serverSide: true,
                "pageLength": 20,
                order: [[0, 'desc']],
                language: require('../../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
                columnDefs: [
                    { orderable: false, searchable: false, targets: -1 },
                    { orderable: false, searchable: false, targets: 2 },
                ],
                "ajax": {
                    'url': $el.data("url"),
                    'data': function(data){
                        //data.search["value"] = $("#client_search").val();
                    }
                },
                "columns": [
                    { "data": "created_at" },
                    { "data": "address" },
                    { "data": "coordinates", "orderable": false },
                    { "data": "result" },
                    { "data": "last_checked_at", "orderable": false },
                    { "data": "actions", "orderable": false },
                ],
                initComplete: () => {
                    this.bindDetailButtons();
                }
            });

            this.fttoDatatables.push(table);

            let $search = $('#' + $el.data("service-name") + 'CustomSearch');

            if ($search.length !== 0) {
                $search.keyup(function() {
                    table.search($(this).val()).draw();
                });
            }
        });
    }

    onSubmitTestEligibility(e){
        e.preventDefault();
        let self = application.current_handler;
        let $el = $(e.currentTarget)

        if(!$el.valid()){ return false; }
        application.openLoader();
        let data = {
            address: $("#address").val() || $("#no-service-address").val(),
            address_a: $("#address_a").val(),
            address_b: $("#address_b").val(),
            service_id: $("#service_id").val(),
            from_workflow: self.fromWorkflow
        };

        let ajax_data = {
            url: $el.data("url"),
            data: data,
            method: "POST",
            success: self.testEligibilitySuccess,
            error: self.testEligibilityError
        }

        $.ajax(ajax_data)
    }

    // toggleTestModal(){
    //   if (this.getApplicationParam("modal_test") === "true") {
    //     console.log("toggleTestModal");
    //     $("#test_modal").modal("show");
    //   }
    // }

    getApplicationParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }
}